var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.821973 15.1158C0.653223 15.1158 0.512598 15.0596 0.371973 14.9471C0.118848 14.6939 0.118848 14.3002 0.371973 14.0471L6.27822 8.0002L0.371973 1.98145C0.118848 1.72832 0.118848 1.33457 0.371973 1.08145C0.625098 0.82832 1.01885 0.82832 1.27197 1.08145L7.62822 7.5502C7.88135 7.80332 7.88135 8.19707 7.62822 8.45019L1.27197 14.9189C1.15947 15.0314 0.990723 15.1158 0.821973 15.1158Z",
    fill: "#637381"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg5);
export default __webpack_public_path__ + "static/media/svg5.b2086feb1572e90dd1bdfec5c9ee1e21.svg";
export { ForwardRef as ReactComponent };